module.exports = __webpack_public_path__ + "img/bgcar.abfba1fe.png";